import { useQuery } from '@tanstack/react-query'
import { useBaseReads } from 'use-towns-client'

export const useTownChannelList = (spaceId: string | undefined) => {
    const { spaceDapp } = useBaseReads()

    const { data: channels, isLoading } = useQuery({
        initialData: [],
        queryKey: ['spaceChannels', spaceId],
        queryFn: () => spaceDapp.getChannels(spaceId ?? ''),
        select: (data) =>
            data
                .filter((c) => !c.disabled)
                .map((c) => ({
                    name: c.name,
                    channelNetworkId: c.channelNetworkId,
                })),
        enabled: !!spaceId,
    })

    return {
        channels,
        isLoading,
        channelCount: channels?.length,
    }
}
